import React, { useRef, useState ,useCallback,useEffect } from 'react';
import './deep-dive-body.scss';
import TrendSummary from '../trend-summary/trend-summary.jsx'
import GrowthTrend from '../growth-trend/growth-trend.jsx'
import SocialBuzz from '../social-buzz/social-buzz.jsx'
import KeyIngredients from '../key-ingredients/key-ingredients.jsx'
import {arrowRightGreen,exportTopRight,exportTopLeft,exportBottomRight,exportBottomLeft,exportLogo,popuoClose, ki} from '../../../../components/icons/icons.jsx';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { Spin, Tooltip } from 'antd';
import { pythonApiURL } from '../../../../env-url.js';
import { getToken } from '../../../../util/api.jsx';

function DeepDiveBody({changeIsDeepDiveVisible=changeIsDeepDiveVisible,loading={loading},err={err},trendingDishData={trendingDishData}}) {
  const sideMenuItems = [
    {title:'Trend Summary'},
    {title:'Growth Trend'},
    {title:'Social Summary'},
    {title:'Key Ingredients'}
  ];
  const [selectedTitle, setSelectedTitle] = useState('Trend Summary');
  const [exportLoading, setExportLoading] = useState(false);
  const [token, setToken] = useState('');
  const fileprefix = `${pythonApiURL}/v1/tdti/filestream?fileinfo=`;
  const getTokenFromInstance = async () => {
    let token = await getToken();
    setToken(token);
  };
  const [trendSummaryImg, setTrendSummaryImg] = useState('');
  const getTrendSummaryImg = async () => {
    let img = await getImgToBase64(trendingDishData.detail.top_dish_variant_image_url_lg)
    setTrendSummaryImg(img)
  }
  // useEffect(() => {
  //   if(token !== ''){
  //     getTrendSummaryImg()
  //   }
  // }, [token]);
  useEffect(() => {
    getTokenFromInstance();
      const observer = new IntersectionObserver(
        (entries) => {
          for (let i=0;i<entries.length;i++){
            const entry = entries[i]
            // console.log(entry.isIntersecting,i)
            if(entry.isIntersecting){
              setSelectedTitle(entry.target.id)
              break
            }
          }
          // entries.forEach((entry) => {
          //   if (entry.isIntersecting) {
          //     setSelectedTitle(entry.target.id)
          //   }
          // });
        },
        { threshold: 0.25,rootMargin:'0px 0px 0px 0px'}
      );
      observer.observe(TrendSummaryRef.current)
      observer.observe(GrowthTrendRef.current)
      observer.observe(SocialBuzzRef.current)
      observer.observe(KeyIngredientsRef.current)
  }, [])
  useEffect(() => {
      if(token !== ''){
        getTrendSummaryImg()
      }
  }, [trendingDishData,token]);
  const SideMenuItem = ({item,index}) =>{
    if(selectedTitle==item.title){
      return(
        <div className='sideMenuItem' onClick={(e)=>handleSideMenuClick(item,index)}>
          <div className='sideMenuText' style={{color:'#26F028'}}>{item.title}</div>
          <img className='selectedArrow' src={arrowRightGreen}/>
        </div>
      )
    }else{
      return(
        <div className='sideMenuItem' onClick={(e)=>handleSideMenuClick(item,index)}>
          <div className='sideMenuText'>{item.title}</div>
        </div>
      )
    }
  };

  const TrendSummaryRef =useRef(null)
  const GrowthTrendRef =useRef(null)
  const SocialBuzzRef=useRef(null)
  const KeyIngredientsRef =useRef(null)
  const printRef = useRef(null)
  const tsRef = useRef(null)
  const gtRef = useRef(null)
  const sbRef = useRef(null)
  const kiRef = useRef(null)

  const handleSideMenuClick = (e,index) => {
    if (e.title == 'Trend Summary') {
        TrendSummaryRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    else if (e.title == 'Growth Trend') {
        GrowthTrendRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    else if (e.title == 'Social Summary') {
        SocialBuzzRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    else if (e.title == 'Key Ingredients') {
        KeyIngredientsRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    // setSelectedTitle(e.title)
  }
  const handleExport = async (e) => {
    setExportLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 2000));

      const element = printRef.current;
      const canvas = await html2canvas(element, {
        backgroundColor: '#000000',
        useCORS: true,
        scale: 2, 
        logging: true,
        allowTaint: true,
        // foreignObjectRendering: true,
        onclone: function(clonedDoc) {
          const exportneedshow = clonedDoc.querySelector('#exportneedshow');
          const tiktokVideosBox = clonedDoc.querySelector('#tiktok-videos-box');
          const metaVideosBox = clonedDoc.querySelector('#meta-videos-box');
          const aiTopDishInfoCircle = clonedDoc.querySelector('#aiTopDishInfoCircle');
          const exportTitle = clonedDoc.querySelector('#exportTitle');
          const fullscreenImg = clonedDoc.querySelector('#fullscreenImg');

          if (exportneedshow) exportneedshow.style.display = 'block';
          if (tiktokVideosBox) tiktokVideosBox.style.display = 'none';
          if (metaVideosBox) metaVideosBox.style.display = 'none';
          if (aiTopDishInfoCircle) aiTopDishInfoCircle.style.display = 'none';
          if (exportTitle) exportTitle.style.display = 'block';
          if (fullscreenImg) fullscreenImg.style.display = 'none';

          const textElements = clonedDoc.querySelectorAll('p, span, h1, h2, h3, h4, h5, h6, div:not(:has(*))');
          textElements.forEach(el => {
            if (el.childNodes.length === 1 && el.childNodes[0].nodeType === 3) {
              const currentTransform = window.getComputedStyle(el).transform;
              if (currentTransform === 'none') {
                el.style.transform = 'translateY(-10px)';
              } else {
                el.style.transform = `${currentTransform} translateY(-10px)`;
              }
            }
          });
          return new Promise(resolve => {
            setTimeout(() => {
              resolve();
            }, 1000);
          });
        }
      });
      
      const imgData = canvas.toDataURL('image/png');
      
      // Calculate dimensions while maintaining aspect ratio
      const imgWidth = 210; // Width in mm (A4 width)
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
      // Create PDF with custom dimensions
      const pdf = new jsPDF('p', 'mm', [imgWidth, imgHeight]);
      
      // Add image to fill the entire PDF
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      
      pdf.save(`Deep-Dive-${trendingDishData.detail.top_dish_variant}_${new Date().toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}.pdf`);
    } catch (error) {
      console.error('Error generating PDF:', error);
    } finally {
      setExportLoading(false);
    }
  };

  const handleClose = (e) =>{
    // console.log(e)
    changeIsDeepDiveVisible(false)
  }

  const getImgToBase64 = async (e) => {
    let url = `${fileprefix}${e}&token=${token}`
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error('Error converting image to base64:', error);
      return null;
    }
  }

  return (
    <div className="container">
        <div className='sideMenu'>
          {sideMenuItems.map((item,index)=>(
            <SideMenuItem item={item} key={index}/>
          ))}
        </div>
        <div className='borderLine'></div>
        
        <div className='export'
          style={{
            pointerEvents: exportLoading ? 'none' : 'auto',
            cursor: exportLoading ? 'not-allowed' : 'pointer',
        }} onClick={handleExport}>
          <img className={`exportLogo ${exportLoading ? 'loading' : ''}`} src={exportLogo}/>
          <img className='exportTR' src={exportTopRight}/>
          <img className='exportTL' src={exportTopLeft}/>
          <img className='exportBR' src={exportBottomRight}/>
          <img className='exportBL' src={exportBottomLeft}/>
          <div className={`exportText ${exportLoading ? 'loading' : ''}`}>
            Export
          </div>
          {exportLoading && <Spin />}
        </div>
        <div className='popupclose' onClick={handleClose}><img src={popuoClose}/></div>
        <div className='detail' ref={printRef}>
            {/* <div className='commonHeader' id='commonHeader' style={{display:'none'}}>
              <div className='headerTitle'>{`Deep Dive - ${trendingDishData.detail.top_dish_variant}`}</div>
            </div> */}
            <div className='exportTitle' style={{display:'none'}} id='exportTitle'>{`Deep Dive - ${trendingDishData.detail.top_dish_variant}`}</div>
                <div ref={TrendSummaryRef} id='Trend Summary'>
                <TrendSummary  trendingDishData={trendingDishData} trendSummaryImg={trendSummaryImg} ref={tsRef}/>
                </div>
                <div ref={GrowthTrendRef} id='Growth Trend'>
                <GrowthTrend loading={loading} err={err} trendingDishData={trendingDishData} ref={gtRef}/>
                </div>
                <div ref={SocialBuzzRef} id='Social Summary'>
                <SocialBuzz loading={loading} err={err} trendingDishData={trendingDishData} ref={sbRef}/>
                </div>
                <div ref={KeyIngredientsRef} id='Key Ingredients'>
                <KeyIngredients ref={kiRef}/>
                </div>
        </div>
    </div>
  );
}

export default DeepDiveBody;
